// Currency code to symbol mapping
const currencySymbols = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  CNY: '¥',
  INR: '₹',
  AUD: 'A$',
  CAD: 'C$',
  CHF: 'CHF',
  NZD: 'NZ$',
  SGD: 'S$',
  HKD: 'HK$',
  KRW: '₩',
  SEK: 'kr',
  NOK: 'kr',
  DKK: 'kr',
  PLN: 'zł',
  THB: '฿',
  MXN: 'Mex$',
  BRL: 'R$',
  ZAR: 'R',
  RUB: '₽',
  TRY: '₺',
  AED: 'د.إ',
  SAR: '﷼',
  QAR: 'ر.ق',
  KWD: 'د.ك',
  BHD: 'د.ب',
  OMR: 'ر.ع.',
  JOD: 'د.ا',
  EGP: 'E£',
  MAD: 'د.م.',
  NGN: '₦',
  KES: 'KSh',
  GHS: '₵',
  XOF: 'CFA',
  XAF: 'FCFA',
  PHP: '₱',
  IDR: 'Rp',
  MYR: 'RM',
  VND: '₫',
  PKR: '₨',
  BDT: '৳',
  LKR: 'Rs',
  NPR: 'Rs',
  AFN: '؋',
  ILS: '₪',
  CZK: 'Kč',
  HUF: 'Ft',
  RON: 'lei',
  BGN: 'лв',
  HRK: 'kn',
  ISK: 'kr',
  UAH: '₴',
  ARS: '$',
  CLP: '$',
  COP: '$',
  PEN: 'S/',
  UYU: '$U',
  VES: 'Bs.',
};

/**
 * Get currency symbol from currency code
 * @param {string} currencyCode - ISO 4217 currency code (e.g., 'USD', 'EUR')
 * @returns {string} - Currency symbol or the currency code if not found
 */
export function getCurrencySymbol(currencyCode) {
  if (!currencyCode) return '$'; // Default to USD symbol
  
  const code = currencyCode.toUpperCase();
  return currencySymbols[code] || code; // Return the code itself if symbol not found
}

/**
 * Format price with currency symbol
 * @param {number} price - The price amount
 * @param {string} currencyCode - ISO 4217 currency code
 * @param {object} options - Formatting options
 * @returns {string} - Formatted price string
 */
export function formatPrice(price, currencyCode, options = {}) {
  const {
    showCode = false, // Whether to show currency code alongside symbol
    locale = 'en-US', // Locale for number formatting
  } = options;

  if (price === null || price === undefined) return '';

  const symbol = getCurrencySymbol(currencyCode);
  const formattedPrice = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);

  if (showCode && currencyCode) {
    return `${symbol}${formattedPrice} ${currencyCode.toUpperCase()}`;
  }

  return `${symbol}${formattedPrice}`;
}

export default { getCurrencySymbol, formatPrice };
